/** Cálculos eneagrama / diseño humano (misma lógica que diagnóstico admin). */

export const ENNEAGRAM_TYPES = {
    1: { name: 'Reformador', emoji: '⚖️', color: '#7B68EE' },
    2: { name: 'Ayudante', emoji: '💛', color: '#FFB347' },
    3: { name: 'Triunfador', emoji: '🏆', color: '#FF6B6B' },
    4: { name: 'Individualista', emoji: '🎨', color: '#9B59B6' },
    5: { name: 'Investigador', emoji: '🔬', color: '#3498DB' },
    6: { name: 'Leal', emoji: '🛡️', color: '#27AE60' },
    7: { name: 'Entusiasta', emoji: '🎉', color: '#F39C12' },
    8: { name: 'Desafiante', emoji: '🦁', color: '#E74C3C' },
    9: { name: 'Pacificador', emoji: '🕊️', color: '#1ABC9C' },
};

export const HD_TYPES = {
    manifestacion: { name: 'Manifestación', emoji: '⚡', color: '#E74C3C' },
    generacion: { name: 'Generación', emoji: '🔥', color: '#F39C12' },
    proyeccion: { name: 'Proyección', emoji: '🎯', color: '#3498DB' },
    reflejo: { name: 'Reflejo', emoji: '🌙', color: '#9B59B6' },
};

export function calcEnneagram(birthDate) {
    if (!birthDate) return null;
    const digits = String(birthDate).replace(/\D/g, '');
    let sum = 0;
    for (const d of digits) sum += parseInt(d, 10);
    while (sum > 9) {
        let newSum = 0;
        for (const d of String(sum)) newSum += parseInt(d, 10);
        sum = newSum;
    }
    return sum || 9;
}

export function calcHumanDesign(birthDate) {
    if (!birthDate) return null;
    const d = new Date(birthDate);
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const seed = (month * 31 + day) % 4;
    const keys = ['manifestacion', 'generacion', 'proyeccion', 'reflejo'];
    return keys[seed];
}
